import React from "react";
const FormControl = (props) => {
  const { Input, Label, error, errorClassName } =
    props;
  const { child, properties } = Label;
  let label;

  if (error) {
    label = (
      <div className={errorClassName}>
        <label {...properties}>
          {child.label}
          <span> *</span>
        </label>
        <p>{error}</p>
      </div>
    );
  } else {
    label = (
      <label {...properties}>{child.label}</label>
    );
  }

  return (
    <div className={props.className}>
      {label}
      <input {...Input} />
    </div>
  );
};

export default FormControl;
